export namespace IRecordCategoryNodesVisibilityRequest {
  export type SourceType =
    | 'SOURCE_UNKNOWN'
    | 'WEB_DESKTOP_TOP_NAV'
    | 'WEB_DESKTOP_TOP_NAV_DROPDOWN'
    | 'WEB_DESKTOP_LEFT_NAV'
    | 'WEB_MOBILE_LEFT_NAV'
    | 'WEB_MOBILE_ROOT_NAV_MENU'
    | 'WEB_MOBILE_SUB_NAV_MENU'
    | 'WEB_DESKTOP_BRAND_LEFT_NAV'
    | 'WEB_DESKTOP_BREADCRUMB'
    | 'WEB_MOBILE_BREADCRUMB'
    | 'WEB_DESKTOP_CAROUSEL_ELEMENT'
    | 'WEB_MOBILE_CAROUSEL_ELEMENT'
    | 'WEB_SEARCH_RESULTS_CATEGORY_FILTER'
    | 'APP_SEARCH_RESULTS'
    | 'APP_NAV_TREE'
    | 'APP_CAROUSEL_ELEMENT'
    | 'HOMEPAGE_COMPONENT'
    | 'CATEGORY_PAGE_COMPONENT'
    | 'PRODUCT_PAGE_COMPONENT'
    | 'SIMILAR_PRODUCTS_PAGE_COMPONENT';

  export enum Source {
    SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
    WEB_DESKTOP_TOP_NAV = 'WEB_DESKTOP_TOP_NAV',
    WEB_DESKTOP_TOP_NAV_DROPDOWN = 'WEB_DESKTOP_TOP_NAV_DROPDOWN',
    WEB_DESKTOP_LEFT_NAV = 'WEB_DESKTOP_LEFT_NAV',
    /**
     * Deprecated. Replaced with WEB_MOBILE_ROOT_NAV_MENU and WEB_MOBILE_SUB_NAV_MENU
     * @deprecated
     */
    WEB_MOBILE_LEFT_NAV = 'WEB_MOBILE_LEFT_NAV',
    WEB_MOBILE_ROOT_NAV_MENU = 'WEB_MOBILE_ROOT_NAV_MENU',
    WEB_MOBILE_SUB_NAV_MENU = 'WEB_MOBILE_SUB_NAV_MENU',
    WEB_DESKTOP_BRAND_LEFT_NAV = 'WEB_DESKTOP_BRAND_LEFT_NAV',
    WEB_DESKTOP_BREADCRUMB = 'WEB_DESKTOP_BREADCRUMB',
    WEB_MOBILE_BREADCRUMB = 'WEB_MOBILE_BREADCRUMB',
    /**
     * @deprecated
     */
    WEB_DESKTOP_CAROUSEL_ELEMENT = 'WEB_DESKTOP_CAROUSEL_ELEMENT',
    /**
     * @deprecated
     */
    WEB_MOBILE_CAROUSEL_ELEMENT = 'WEB_MOBILE_CAROUSEL_ELEMENT',
    WEB_SEARCH_RESULTS_CATEGORY_FILTER = 'WEB_SEARCH_RESULTS_CATEGORY_FILTER',
    APP_SEARCH_RESULTS = 'APP_SEARCH_RESULTS',
    APP_NAV_TREE = 'APP_NAV_TREE',
    APP_CAROUSEL_ELEMENT = 'APP_CAROUSEL_ELEMENT',
    HOMEPAGE_COMPONENT = 'HOMEPAGE_COMPONENT',
    CATEGORY_PAGE_COMPONENT = 'CATEGORY_PAGE_COMPONENT',
    PRODUCT_PAGE_COMPONENT = 'PRODUCT_PAGE_COMPONENT',
    SIMILAR_PRODUCTS_PAGE_COMPONENT = 'SIMILAR_PRODUCTS_PAGE_COMPONENT',
  }

  /**
   * Return an instance of IRecordCategoryNodesVisibilityRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRecordCategoryNodesVisibilityRequest>
  ): IRecordCategoryNodesVisibilityRequest =>
    ({
      path_identifiers: [],
      ...(partial ?? {}),
    }) as IRecordCategoryNodesVisibilityRequest;
}

export interface IRecordCategoryNodesVisibilityRequest {
  path_identifiers: Array<string>;
  source: keyof typeof IRecordCategoryNodesVisibilityRequest.Source | undefined;
}
